import { createSlice } from '@reduxjs/toolkit'

export const userStore = createSlice({
    name: 'user-store',
    initialState: {
        loginState: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        mode: localStorage.getItem('loginMode') ? localStorage.getItem('loginMode') : '',
        isIframe: false
    },
    reducers: {
        setUserLoginMode: (state, action) => {
            state.mode = action.payload
        },
        setUserLoginState: (state, action) => {
            state.loginState = action.payload
        },
        setIsIframe: (state, action) => {
            state.isIframe = action.payload
        }
    }
})

export const { setUserLoginMode, setUserLoginState, setIsIframe } = userStore.actions
export default userStore.reducer